import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material"
import { DataNode } from "graphql/types"
import { default as Markdown } from "markdown-to-jsx"

type ReportNodeTableBoxProps = {
  data: DataNode
}

export const ReportNodeTableBox = (props: ReportNodeTableBoxProps) => {
  const { data } = props
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="caption">
        Table {data.tableNumber}: {data.tableCaption}
      </Typography>
      <Table size="small" sx={{ border: "2px solid", borderColor: "divider" }}>
        <TableHead>
          <TableRow>
            {data.tableHeader.map((header, index) => (
              <TableCell
                key={index}
                sx={{ border: "2px solid", borderColor: "divider" }}
                colSpan={header.colSpan}
              >
                <Markdown options={{ forceBlock: false }}>{header.data}</Markdown>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.tableBody.map((row, rowIndex) => (
            <TableRow key={rowIndex} style={{ whiteSpace: "pre-wrap" }}>
              {row.map((cell, cellIndex) => (
                <TableCell
                  key={cellIndex + "-" + rowIndex}
                  colSpan={cell.colSpan}
                  sx={{ border: "2px solid", borderColor: "divider" }}
                >
                  <Markdown options={{ forceBlock: false }}>{cell.data}</Markdown>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  )
}
